import React from 'react';
import { Activity } from 'lucide-react';
import { FeatureCard } from './components/FeatureCard/FeatureCard';
import './FeaturesOverview.css';

const FEATURES_DATA = [
  {
    icon: Activity,
    tag: 'NEW & LIVE',
    title: 'AI 실시간 자세 분석',
    description: '웹캠을 통해 측면 33개 관절 뼈대를 실시간 추론하여 당김팔과 스탠스 밸런스를 측정합니다.',
    isHighlighted: true,
  },
];

export function FeaturesOverview() {
  const handleSelectFeature = () => {
    const guideEl = document.getElementById('pose-guide');
    if (guideEl) {
      guideEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      guideEl.classList.remove('pose-guide--focused');
      // trigger reflow for re-running animation
      void guideEl.offsetWidth;
      guideEl.classList.add('pose-guide--focused');
      guideEl.focus();
    }
  };

  return (
    <section className="features-overview">
      <div className="features-overview__grid">
        {FEATURES_DATA.map((item, idx) => (
          <FeatureCard
            key={idx}
            {...item}
            onClick={handleSelectFeature}
          />
        ))}
      </div>
    </section>
  );
}

